// packages/analytics/src/envelope.ts
export type Product = 'intelhub' | 'cyberfind-io'
export type Env = 'prod' | 'dev'
export type UserRole = 'ciso' | 'operator' | 'anon'

export interface Envelope {
  product: Product
  env: Env
  user_role: UserRole
}

export function buildEnvelope(product: Product, env: Env, userRole: UserRole): Envelope {
  return { product, env, user_role: userRole }
}
